import { put, takeLatest, call } from 'redux-saga/effects'

import * as orderService from '../../../services/orderService'
import {
  UNDISPATCH_ORDER,
  UNDISPATCH_ORDER_SUCCESS,
  UNDISPATCH_ORDER_ERROR
}
  from '../../actions/order'

function * unDispatchOrderSaga (action) {
  try {
    const data = yield call(orderService.UnDispatchOrder, action.payload)

    yield put({
      type: UNDISPATCH_ORDER_SUCCESS,
      payload: data
    })
  } catch (error) {
    yield put({
      type: UNDISPATCH_ORDER_ERROR, error: error.data
    })
  }
}

export function * unDispatchOrderSagaWatcher () {
  yield takeLatest(UNDISPATCH_ORDER, unDispatchOrderSaga)
}
